export default {"src":"/_next/static/media/partner9.172ab0ca.svg","height":70,"width":123,"blurWidth":0,"blurHeight":0};